/* eslint-disable max-len */
import 'react';

const SidebarDocSvg = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="22.118%" y1="19.419%" x2="91.637%" y2="63.357%" id="wiki_icon_SidebarDocSvg_prefix__a">
                <stop stopColor="#909AC3" offset="0%" />
                <stop stopColor="#7F88AD" offset="100%" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                d="M11.352 2.778a2 2 0 011.433.604l2.77 2.845a2 2 0 01.567 1.395v8.6a1 1 0 01-1 1H4.9a1 1 0 01-1-1V3.778a1 1 0 011-1h6.452zm.51 10.055H7.05l-.097.008a.568.568 0 00-.497.548c0 .307.266.555.594.555h4.736a2 2 0 00.15-.005l.022-.002a.568.568 0 00.498-.548c0-.307-.266-.556-.595-.556zm-1.55-2.333H7.05l-.097.007a.568.568 0 00-.497.549c0 .306.266.555.594.555h3.187a2 2 0 00.15-.006l.022-.001a.568.568 0 00.497-.548c0-.307-.265-.556-.594-.556z"
                fill="url(#wiki_icon_SidebarDocSvg_prefix__a)"
            />
        </g>
    </svg>
);

export default SidebarDocSvg;
